import { _clearReturnLocation, _resetState, _setMeta, _setReturnModel } from './store/mutations'
import { MetaState, ReturnModelPayload } from './store/types'

/**
 * Replaces the Vuex `system` actions. Those were pass-throughs to their mutations, so this is
 * the write API the rest of the app uses instead of `$store.dispatch(SET_META, ...)`.
 */
export function systemService () {
  /**
   * Remembers where the user was mid-flow so a nested create can return them afterwards.
   */
  function setReturnModel (payload: ReturnModelPayload) {
    _setReturnModel(payload)
  }

  function clearReturnLocation () {
    _clearReturnLocation()
  }

  function setMeta (payload: Partial<MetaState>) {
    _setMeta(payload)
  }

  function resetState () {
    _resetState()
  }

  return {
    setReturnModel,
    clearReturnLocation,
    setMeta,
    resetState
  }
}
